(function ($, njm) {
    'use strict';

    njm.views.carouselHero = Backbone.View.extend({

        /**
         * Initialize
         */
        initialize: function () {
			this.initializeSlick();
		},
		
		initializeSlick: function() {
			$('.comp-carousel-hero').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				dots: true,
				prevArrow: '<div class="arrow prev">\n<i type="button" class="slick-prev">Previous</button>\n</div>\n',
				nextArrow: '<div class="arrow next">\n<button type="button" class="slick-next">Previous</button>\n</div>\n',
				responsive: [
					{
					  breakpoint: 768,
					  settings: {
						arrows: false
					  }
					}
				]
			});
		}
    });
})(jQuery, njm);